// extracted by mini-css-extract-plugin
module.exports = {"ibx-logo":"AuthForm_ibx-logo__wl3sI","control":"AuthForm_control__2fVSU","actions":"AuthForm_actions__1VNhY"};